module.exports = __webpack_public_path__ + "img/home_3.4886d08d.svg";